<template>
  <transition name="modal" appear>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close button" @click="$emit('close')">
            <i class="button__icon material-icons">close</i>
          </button>

          <div>
            <slot v-if="hasHeaderSlot" name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div>
            <slot v-if="hasFooterSlot" name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  computed: {
    hasHeaderSlot() {
      return !!this.$slots['header'];
    },
    hasFooterSlot() {
      return !!this.$slots['footer'];
    },
  },
};
</script>

<style></style>
